import type { ReactNode } from 'react';
import { PipelineBoard as Board } from './components';

export function Pipeline(): ReactNode {
  return (
    <div className="h-full flex flex-col">
      <div className="px-4 py-3 border-b bg-white">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-semibold text-gray-900">Sales Pipeline</h1>
          <button className="btn btn-primary">
            + New Deal
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-hidden">
        <Board />
      </div>
    </div>
  );
}

export { PipelineBoard, DealCard, StageColumn } from './components';
export default Pipeline;
